import React from 'react';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface AccessDeniedProps {
  moduleName?: string;
  onGoBack?: () => void;
}

const AccessDenied = ({ moduleName, onGoBack }: AccessDeniedProps) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldX className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-xl">Acesso Restrito</CardTitle>
          <CardDescription>
            {moduleName 
              ? `Você não tem acesso ao módulo "${moduleName}".`
              : 'Você não tem permissão para acessar este recurso.'
            }
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Entre em contato com o administrador da sua empresa para solicitar acesso 
            ou faça upgrade do seu plano para desbloquear este módulo.
          </p>
          {onGoBack && (
            <Button onClick={onGoBack} variant="outline">
              Voltar ao Dashboard
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;
